import '@angular/localize/init';

import 'zone.js';
(globalThis as any).global = globalThis;
